import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme, $loading }) => css`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 0 40px 40px;

    ${$loading && css`
      justify-content: center;
      align-items: center;
    `}
    
    @media (max-width: ${theme.breakpoints.md}) {
      padding: 0;
    }

    @media (max-width: ${theme.breakpoints.sm}) {
      padding: 0 0 120px 0;
    }
  `}
`;

export const Row = styled.div`
  ${({ theme, $paddingBottom }) => css`
    background-color: ${theme.v2.colors.neutral.highPure};
    border-radius: 16px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: ${$paddingBottom ? '48px' : '48px 48px 0px'};
    align-items: flex-start;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      padding: ${$paddingBottom ? '20px' : '20px 20px 0px'};
    }
  `}
`;

export const Column = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    max-width: 600px;

    @media (max-width: ${theme.breakpoints.md}) {
      max-width: 100%;
    }
  `}
`;

export const WithAi = styled.span`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.brand.primaryUltraLight};
    border-radius:10px;
    color: ${theme.v2.colors.brand.primaryDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.bold};
    padding: 4px 8px;
    width: fit-content;
  `}
`;

export const CardTitle = styled.h3`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryDarkExtraDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.lg};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 8px 0px 0px;
    max-width: 550px;
  `}
`;

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap:15px;
  list-style: none;
  margin: 16px 0px 0px;
  padding: 0px;
`;

export const ListItem = styled.li`
    ${({ theme }) => css`
      align-items: center;
      color: ${theme.v2.colors.neutral.lowPure};
      display: flex;
      flex-direction: row;
      font-family: ${theme.v2.font.family.primary};
      font-size: ${theme.v2.font.sizes.xs};
      font-weight: ${theme.v2.font.weights.regular};
      gap: 4px;
      max-width: 600px;
    `}
`;


export const CtaRow = styled.div`
  ${({ theme }) => css`
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 16px;
    margin: 24px 0px 20px 0px;
    flex-wrap: wrap;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      margin: 24px 0px 0px 0px;
    };

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      justify-content: center;
    };
  `};
`;

export const CtaDescription = styled.span`
    ${({ theme }) => css`
      color: ${theme.v2.colors.neutral.lowMedium};
      display: flex;
      flex-direction: column;
      font-family: ${theme.v2.font.family.primary};
      font-size: ${theme.v2.font.sizes.xxs};
      font-weight: ${theme.v2.font.weights.regular};
      max-width: 160px;
      line-height: 21px;


    @media (max-width: ${theme.v2.breakpoints.md}) {
      max-width: unset;
    }
    `}
`;

export const Image = styled.img`
    max-width: 100%
    ;
`;

export const FaqItemText = styled.span`
    ${({ theme }) => css`
      color: ${theme.v2.colors.neutral.lowPure};
      font-family: ${theme.v2.font.family.primary};
      font-size: ${theme.v2.font.sizes.xs};
      font-weight: ${theme.v2.font.weights.regular};
    `}
`;

export const FaqItemInsideList = styled.ul`
    padding: 0px 24px;
    margin: 0px;
    display: flex;
    flex-direction: column;
`;

export const FaqItemInsideListItem = styled.li`
    ${({ theme }) => css`
      color: ${theme.v2.colors.neutral.lowPure};
      font-family: ${theme.v2.font.family.primary};
      font-size: ${theme.v2.font.sizes.xs};
      font-weight: ${theme.v2.font.weights.regular};
    `}
`;
